var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C53434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.333 5.147h13.334m-8.334 8.824V8.676m3.334 5.295V8.676m1.666 8.824H6.667C5.747 17.5 5 16.71 5 15.735V6.03c0-.487.373-.882.833-.882h8.334c.46 0 .833.395.833.882v9.706c0 .975-.746 1.765-1.667 1.765Zm-5-12.353h3.334c.46 0 .833-.395.833-.882v-.883c0-.487-.373-.882-.833-.882H8.333c-.46 0-.833.395-.833.882v.883c0 .487.373.882.833.882Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.4aa61486411ee6190ce8d7c16d9de2be.svg";
export { ForwardRef as ReactComponent };